export const EventType = {
	callEvents: {
		guestIdentified: 'IM:Guest:onAfterGuestNamePopupClose',
		guestInitialChatOpen: 'IM:Guest:onInitialChatOpen',
	},
};
